import { FeatureFlagKeys } from '@modules/FeatureFlagModule';
import useFeatureFlag from '@modules/FeatureFlagModule/hooks/useFeatureFlag/useFeatureFlag';
import { useServiceQueuesState } from './useServiceQueuesState';
import QueuesTable from './QueuesTable/QueuesTable';
import { OutboundCallDetails } from '../types';

interface IOutboundModalQueuesProps {
  setCallDetails: (details: OutboundCallDetails) => void;
}

const OutboundModalQueues: React.FC<IOutboundModalQueuesProps> = ({
  setCallDetails,
}) => {
  const useStrictAvailability = useFeatureFlag(
    FeatureFlagKeys.featureShowQueueWarningInTransfer,
    { defaultValue: false },
  );
  const { queues, loading } = useServiceQueuesState({ useStrictAvailability });
  return (
    <QueuesTable
      queues={queues}
      loading={loading}
      setCallDetails={setCallDetails}
      initialSort={[{ field: 'estimatedWait', dir: 'asc' }]}
      useStrictAvailability={useStrictAvailability}
    />
  );
};

export default OutboundModalQueues;
